module.exports = __webpack_public_path__ + "img/messages_messages-config-2.89211d4c.jpg";